module.exports = __webpack_public_path__ + "media/pyra-and-mythra.ab0cb775.wav";